// src/components/appointments/call/callStates.js

export const CALL_STATES = {
  IDLE: "idle",
  CONNECTING: "connecting",
  RINGING: "ringing",
  IN_CALL: "in_call",
  RECONNECTING: "reconnecting",
  ENDED: "ended",
};

export function phaseText(phase) {
  if (phase === CALL_STATES.CONNECTING) return "Connecting…";
  if (phase === CALL_STATES.RINGING) return "Ringing…";
  if (phase === CALL_STATES.RECONNECTING) return "Reconnecting…";
  return "";
}